import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const newsCarousel = document.querySelector('.featured-news__carousel');

  if (newsCarousel) {
    const newsCarouselSlides = newsCarousel.querySelectorAll('.swiper-slide');
    const carouselArgs = {
      slidesPerView: 1,
      loop: false,
      navigation: {
        prevEl: '.featured-news__carousel__navigation .swiper-button-prev',
        nextEl: '.featured-news__carousel__navigation .swiper-button-next',
      },
      pagination: {
        el: '.featured-news__carousel__navigation .swiper-pagination',
        type: 'fraction',
      },
      a11y: {
        prevSlideMessage: _x(
          'See previous slide',
          'slider previous label',
          'vtx'
        ),
        nextSlideMessage: _x('See next slide', 'slider next label', 'vtx'),
        paginationBulletMessage: _x(
          'Go to slide {{index}}',
          'slide pagination label',
          'vtx'
        ),
        slideLabelMessage: _x(
          'Slide {{index}} of {{slidesLength}}',
          'slide label',
          'vtx'
        ),
      },
    };
    if (1 < newsCarouselSlides.length) {
      carouselArgs.loop = true;
    }
    new Swiper(newsCarousel, carouselArgs);
  }
});
